import $ from 'cash-dom'
import { updateURLParam } from '../utilities/toolkit'
import { getDiscountPercentage } from './product-pricing'
import { closeModal } from '@/scripts/components/modal-panel.js'

const productForm = $('[data-component="product-form"]')
const addToCartButton = productForm.find('[data-element="add-to-cart-button"]')
const subscriptionInputs = productForm.find(
  '[data-element="subscription-input"], #sub-interval-frequency'
)
const oneTimeInfoPanel = productForm.find('[data-element="one-time-info"]')
const productPriceElement = $('[data-content="product-price"]')

const salePrice = $(productPriceElement).attr('data-sale')
const oneTimePrice = $(productPriceElement).attr('data-otp')
const fullPrice = $(productPriceElement).attr('data-compare')
const discountTypes =
  Pura.cart?.discount_types?.split(',').map((s) => s.trim()) || false

const hasDiscountTag =
  Pura.product?.tags?.some((tag) => tag.startsWith('discount_')) ||
  Pura.productForm?.includedProducts?.some(
    (includedProduct) => getDiscountPercentage(includedProduct?.tags) > 0
  ) ||
  false

$('[data-element="subscription-price"]').html(salePrice)
$('[data-element="subscription-compare-price"]').html(fullPrice)
$('[data-element="subscription-one-time-purchase-price"]').html(oneTimePrice)

// Only show compare price if different from one-time price
const compareElement = $('[data-element="subscription-one-time-compare-price"]')
if (oneTimePrice !== fullPrice) {
  compareElement.html(fullPrice).show()
} else {
  compareElement.hide()
}

const handleSelectSubscribe = async () => {
  updateURLParam('variant', null)
  addToCartButton.attr('data-state', 'subscribe')
  subscriptionInputs.prop('disabled', false)
  oneTimeInfoPanel.addClass('hidden')
  $('.pdp-purchase-type-sub').each(function () {
    $(this).click()
  })
  // Change display price to SUB with OTP crossed out
  productPriceElement.html(
    `${salePrice}
          <span class="line-through fs-16 opacity-50">
            ${fullPrice}
          </span>`
  )
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-element="subscribe-button"]')
  if (!btn) return
  handleSelectSubscribe()
  $('[data-component="product-form"]').submit()
  setTimeout(() => {
    closeModal(e.target)
  })
})

// Product form OTP and SUB options
$(
  '[data-component="product-form"] [name="pdp-purchase-type"], [data-component="product-form"] [name="included-products-purchase-type"]'
).on('change', (e) => {
  const value = e.target.getAttribute('value')
  // Subscription product
  if (value == 'SUB') {
    handleSelectSubscribe()
    return
  }

  // Normal product
  updateURLParam('variant', Pura.product?.variants[0]?.id)
  subscriptionInputs.prop('disabled', true)
  oneTimeInfoPanel.removeClass('hidden')
  $('.pdp-purchase-type-otp, #included-products-schedule-otp').each(
    function () {
      $(this).click()
    }
  )

  // Show one-time price with compare price only if different
  if (oneTimePrice !== fullPrice) {
    productPriceElement.html(
      `${oneTimePrice}<span class="line-through fs-16 opacity-50">${fullPrice}</span>`
    )
  } else {
    productPriceElement.html(oneTimePrice)
  }
  addToCartButton.attr('data-state', 'add-to-cart')
})

const $sticky = $('[data-element="sticky-add-to-cart-button"]')
let $placeholder = null

function mountStickyToBody() {
  if (!$sticky.length) return

  // Keep a spot to restore if needed
  if (!$placeholder) {
    $placeholder = $('<div style="display:none" data-sticky-placeholder></div>')
    $sticky.before($placeholder)
  }

  $sticky.appendTo(document.body)
}

// Run on DOM ready
$(mountStickyToBody)
